@if (isReady) {

  <mat-drawer-container class="drawer-container" [dir]="direction">
    <mat-drawer
      #sidebar
      class="pc-sidebar"
      [mode]="modeValue"
      opened
      [ngClass]="{
      compact: currentLayout === 'compact',
      horizontal: currentLayout === 'horizontal'
    }"
    >
      <nav>
        <div class="navbar-wrapper">
          <div class="m-header" [ngClass]="{ 'bg-primary-500': (auth$ | async)?.personalize?.logotypeColoring }">
            <a href="/">
              @if ((auth$ | async)?.personalize?.logotypeColoring) {
                @if ((auth$ | async)?.personalize?.invertLogotype) {
                  <img
                    class="brand-header"
                    [src]="(auth$ | async)?.personalize.invertLogotype.url"
                  />
                }

              } @else {
                @if ((auth$ | async)?.personalize?.logotype) {
                  <img
                    class="brand-header"
                    [src]="(auth$ | async)?.personalize.logotype.url"
                  />
                }
              }
            </a>
          </div>
          @if (currentLayout === 'vertical') {
            <app-vertical-menu [menus]="menus"></app-vertical-menu>
          }
          @if (currentLayout === 'compact') {
            <app-compact-menu [menus]="menus"></app-compact-menu>
          }
        </div>
      </nav>
    </mat-drawer>
    <div>
      <app-global-map />
      <app-nav-bar
        [ngClass]="{
        'horizontal-navbar': currentLayout === 'horizontal'
      }"
      ></app-nav-bar>
      @if (currentLayout === 'horizontal') {
        <app-horizontal-menu
          [menus]="menus"
          [ngClass]="{
          'horizontal-menu': currentLayout === 'horizontal'
        }"
        ></app-horizontal-menu>
      }
      <div class="app-container">
        <div class="main-body">
          <div class="page-wrapper">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </mat-drawer-container>
  <app-configuration></app-configuration>
}
